import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import { Icon } from '@iconify/react'
import styles from './styles'

const EXAMPLE =
  'Help new employees understand our expense policy and file expense reports correctly.'
const MAX_LENGTH = 250

const CourseAbout = ({
  classes,
  courseAbout,
  onCourseAboutChange,
  currentCharCount,
}) => {
  return (
    <div className={classes.courseInfo}>
      <div className={classes.courseInfoTitleBetween}>
        <span className={classes.sectionLabel}>What is your course about?</span>
        <button
          type="button"
          className={classes.example}
          onClick={() => onCourseAboutChange({ target: { value: EXAMPLE } })}
        >
          <Icon icon="tabler:info-circle" width={13} height={13} />
          Use an example
        </button>
      </div>
      <textarea
        className={classes.textarea}
        rows={2}
        maxLength={MAX_LENGTH}
        placeholder="Help learners master X skill or understand Y concept."
        value={courseAbout}
        onChange={onCourseAboutChange}
      />
      <span className={classes.count}>
        {currentCharCount} / {MAX_LENGTH}
      </span>
    </div>
  )
}

export default withStyles(styles)(CourseAbout)
